const addLinksToMessages = () => {
  const res = {}
  const messages = [
    'Your Account Takeover Protection is not active. To enable these features, please reintegrate your Office 365 account in the Email Server/Services settings',
    'Your Teams Protection is not active. To enable these features, please reintegrate your Office 365 account in the Email Server/Services settings',
    'Your Account Takeover and Teams Protection are not active. To enable these features, please reintegrate your Office 365 account in the Email Server/Services settings',
    'Your advanced integration is missing the required permissions. Please re-integrate it and ensure all necessary permissions are granted via Settings → Email Server/Services → Advanced Actions Integration.',
    'Your Office 365 integration is missing required permissions. Please re-integrate it in the Email Server/Services settings to restore full functionality.',
  ]
  messages.map((elem, index) => {
    let text = elem
    text = text.replace(
      'Account Takeover',
      '<a href="https://support.ironscales.com/hc/en-us/articles/4403248279314-Account-Takeover-ATO-Incidents" target="_blank">Account Takeover</a>'
    )
    text = text.replace(
      'Teams Protection',
      '<a href="https://support.ironscales.com/hc/en-us/articles/4413001785116-Microsoft-Teams-Incidents" target="_blank">Teams Protection</a>'
    )
    text = text.replace(
      'Email Server/Services settings',
      '<a href="/settings/integrations/email-server" target="_blank">Email Server/Services settings</a>'
    )
    text = text.replace(
      'Settings → Email Server/Services → Advanced Actions Integration',
      '<a href="/settings/integrations/email-server" target="_blank"><strong>Settings → Email Server/Services → Advanced Actions Integration</strong></a>'
    )
    res[index + 1] = text
    return res
  })
  return res
}

export const REINTEGRATION_MESSAGE_OPTIONS = addLinksToMessages()
